import React from 'react';
import styled from '@emotion/styled';
import Img, { FixedObject } from 'gatsby-image';
import ReviewStarIco from '../images/icons/review-star-orange.svg';
import { Name } from '../ui/TypographyStyles';

const CardUser = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

const CardAvatar = styled.div`
  width: 60px;
  height: 60px;
  margin-right: 16px;
`;

const Star = styled.span`
  display: inline-block;
  background: url(${ReviewStarIco});
  width: 20px;
  height: 20px;
`;

interface Props {
  name: string;
  starCount: number;
  fixedImage?: FixedObject;
  className?: string;
}

const UserStarAvatar = ({ fixedImage, starCount, name, className }: Props) => (
  <CardUser className={className}>
    <CardAvatar>{fixedImage && <Img fixed={fixedImage} />}</CardAvatar>
    <span>
      <Name>{name}</Name>
      <br />
      {new Array(starCount).fill(<Star />)}
    </span>
  </CardUser>
);

export default UserStarAvatar;
